import type { BoxProps } from '../box'
import type { NotificationLayout } from './notification.types'

import Box from '../box'
import { useStyleConfig, vui } from '../core'
import { cs } from '../utils'
import { useNotificationContext } from './context'

/** Displays an action button within the Notification. */
export const NotificationAction = vui<'div', BoxProps>((props, ref) => {
  const { children, className, ...rest } = props
  const ctx = useNotificationContext()
  const styles = useStyleConfig('Notification', ctx)

  // Q10: When rendered inside a button-down layout, the action region stretches
  // full-width and exposes `data-layout` so consumers (and the SCSS reference)
  // can scope styles to the button-down CTA without coupling to Button internals.
  // TODO(763859 follow-up): inject intent-colored Button variant when the child
  // is a VUI Button without an explicit `variant` prop.
  const layout = (ctx as { layout?: NotificationLayout })?.layout
  const isButtonDown = layout === 'button-down'

  return (
    <Box
      className={cs('vui-notificationAction', className)}
      ref={ref}
      data-layout={layout}
      w={isButtonDown ? '100%' : undefined}
      {...styles.actionBox}
      {...rest}
    >
      {children}
    </Box>
  )
})

NotificationAction.displayName = 'NotificationAction'
export default NotificationAction
